import React from "react";
import CatalogueEditor from "../../common/catalogue/CatalogueEditor";

export default function RestaurantCataloguePage() {
  return <CatalogueEditor kind="restaurant" />;
}
